exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes resizeSensorVisibility{0%{top:0}}@keyframes resizeSensorVisibility{0%{top:0}}", ""]);

// exports
